import React from "react";
import { useTranslation } from "react-i18next";

const NotificationHeader = ({ 
  notificationsCount, 
  onMarkAllAsRead, 
  markAllMutationPending 
}) => {
  const { t } = useTranslation();
  
  return (
    <div className="bg-gradient-to-r from-blue-600 to-purple-600 px-6 py-8">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-white">{t("notifications.title")}</h1>
          <p className="text-blue-100 mt-2">
            {notificationsCount} {t("notifications.title")}
          </p>
        </div>
        {notificationsCount > 0 && (
          <button
            onClick={onMarkAllAsRead}
            disabled={markAllMutationPending}
            className="px-4 py-2 bg-white/20 text-white rounded-lg hover:bg-white/30 transition-all duration-200 disabled:opacity-50"
          >
            {markAllMutationPending ? (
              <div className="flex items-center space-x-2">
                <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                <span>{t("common.loading")}</span>
              </div>
            ) : (
              t("notifications.markAllAsRead")
            )}
          </button>
        )}
      </div>
    </div>
  );
};

export default NotificationHeader; 